function initSpeechRecognition({
                                 lang = 'es-CO',
                                 continuous = false,
                                 interimResults = false,
                                 onResult,
                                 onError,
                                 onEnd,
                                 commands = [],
                                 onCommandMatch,
                                 onCommandNotMatch,
                                 strictMode = false, // Si es true, solo acepta comandos exactos
                                 similarity = 0.7, // Umbral de similitud para coincidencias aproximadas
                               } = {}) {
  if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window))
    throw Error('Speech recognition not supported');

  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList;

  const recognition = new SpeechRecognition();
  recognition.lang = lang;
  recognition.continuous = continuous;
  recognition.interimResults = interimResults;

  // Configurar gramática si hay comandos
  if (commands.length > 0 && SpeechGrammarList) {
    const grammar = `#JSGF V1.0; grammar comandos; public <comando> = ${commands.join(' | ')};`;
    const speechRecognitionList = new SpeechGrammarList();
    speechRecognitionList.addFromString(grammar, 1);
    recognition.grammars = speechRecognitionList;
  }

  // Función para calcular similitud entre strings (algoritmo Levenshtein simplificado)
  function calculateSimilarity(str1, str2) {
    const longer = str1.length > str2.length ? str1 : str2;
    const shorter = str1.length > str2.length ? str2 : str1;

    if (longer.length === 0) return 1.0;

    const editDistance = levenshteinDistance(longer, shorter);
    return (longer.length - editDistance) / longer.length;
  }

  function levenshteinDistance(str1, str2) {
    const matrix = [];

    for (let i = 0; i <= str2.length; i++) {
      matrix[i] = [i];
    }

    for (let j = 0; j <= str1.length; j++) {
      matrix[0][j] = j;
    }

    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }

    return matrix[str2.length][str1.length];
  }

  // Función para validar comandos
  function validateCommand(transcript) {
    if (commands.length === 0) {
      return {isValid: true, command: transcript, confidence: 1.0};
    }

    const cleanTranscript = transcript.toLowerCase().trim();

    // Buscar coincidencia exacta
    for (const command of commands) {
      const cleanCommand = command.toLowerCase().trim();
      if (cleanCommand === cleanTranscript) {
        return {
          isValid: true,
          command: command,
          matchType: 'exact',
          confidence: 1.0,
          transcript: transcript
        };
      }
    }

    // Si está en modo estricto, no buscar coincidencias aproximadas
    if (strictMode) {
      return {
        isValid: false,
        command: null,
        matchType: 'none',
        confidence: 0,
        transcript: transcript,
        availableCommands: commands
      };
    }

    // Buscar coincidencia aproximada
    let bestMatch = null;
    let bestSimilarity = 0;

    for (const command of commands) {
      const cleanCommand = command.toLowerCase().trim();
      const currentSimilarity = calculateSimilarity(cleanCommand, cleanTranscript);

      if (currentSimilarity > bestSimilarity && currentSimilarity >= similarity) {
        bestSimilarity = currentSimilarity;
        bestMatch = command;
      }
    }

    if (bestMatch) {
      return {
        isValid: true,
        command: bestMatch,
        matchType: 'approximate',
        confidence: bestSimilarity,
        transcript: transcript
      };
    }

    return {
      isValid: false,
      command: null,
      matchType: 'none',
      confidence: 0,
      transcript: transcript,
      availableCommands: commands
    };
  }

  recognition.onresult = (event) => {
    const transcript = event.results[0][0].transcript;
    const validation = validateCommand(transcript);

    // Ejecutar callback de resultado general
    if (typeof onResult === 'function') {
      onResult(transcript, validation);
    }

    // Ejecutar callbacks específicos de comandos
    if (validation.isValid) {
      if (typeof onCommandMatch === 'function') {
        onCommandMatch(validation);
      }
    } else {
      if (typeof onCommandNotMatch === 'function') {
        onCommandNotMatch(validation);
      }
    }
  };

  recognition.onerror = (event) => {
    if (typeof onError === 'function') {
      onError(event.error, event);
    } else {
      console.error('[SpeechRecognition] error:', event.error);
    }
  };

  recognition.onend = () => {
    if (typeof onEnd === 'function') {
      onEnd();
    }
  };

  return recognition;
}

export default initSpeechRecognition;